import React from 'react';
import siteSuspensoImg from '../../../assets/static_img/site-suspenso.png';
import logoCarmine from '../../../assets/static_img/logo_carmine.svg';
import css from './inativarsite.module.css';

export default function SiteIndisponivel() {
  return (
    <div className={css.divMaior}>
      <img src={siteSuspensoImg} alt="Site Suspenso" className={css.mainImage} />

      <div className={css.conteudoTexto}>
        <h1 className={css.titleText}>Estamos temporariamente indisponíveis.</h1>
        <p className={css.descriptionText}>
          Neste momento, o nosso site está em pausa, mas continuamos disponíveis para o atender.
          Agradecemos o interesse e convidamo-lo a voltar em breve.<br></br>
          Obrigado pela compreesão.
        </p>
      </div>
      <hr className={css.dividerLine} />
      <div className={css.conteudoImg}>
        <p className={css.descriptionText}>Desenvolvido por:</p>
        <img src={logoCarmine} alt="Logo Carmine" className={css.logoImageSuspend} />
      </div>
    </div>
  );
}
